<template>
  <div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id = "change_in_veh_idv"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#ChangeInVehIDV"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Change in Vehicle IDV</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="ChangeInVehIDV">
        <div class="risk row">
            <!--Vehicle IDV* starts-->
          <div class="col-lg-3 col-md-3 col-sm-6" v-if="changeInVehicleIDVData.vehicleIDV.visibility">
            <div class="row form-group">
              <float-label label="Vehicle IDV*" :fixed="isFloat(changeInVehicleIDVData.vehicleIDV.value)"> 
                <input
                  v-model="changeInVehicleIDVData.vehicleIDV.value"
                  v-evolvews="changeInVehicleIDVData.vehicleIDV"
                  v-on:keydown="onlyNumber" 
                  type="text"
                  @blur="valiadteVehicleidv()"
                  :class="{'bgc-error-field':changeInVehicleIDVData.vehicleIDV.errorText !== '','idv-range-error': state.validateIdvRange}"
                  class="form-control"
                  placeholder="Vehicle IDV*"
                />
              </float-label>
               <span class="error-text" v-if="changeInVehicleIDVData.vehicleIDV.errorText !== ''">
                    {{changeInVehicleIDVData.vehicleIDV.errorText}}</span>
            <p class="vehicleIdv-msg mt-2" :class="{ 'text-danger': state.validateIdvRange }"
            >Vehicle IDV Range :
            <span class="font-weight-bold"> {{idvLowerPermissibleRange}}</span>-<span class="font-weight-bold">
              {{idvUpperPermissibleRange}}</span>
            </p>
            </div>
          </div>
          <!--Vehicle IDV* ends-->
        </div>
    </div>
  </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import functions from "@/../../masters/functions.js";
import base from "@/../../masters/base.js";
import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
import vSelect from "vue-select";
import { reactive, onUpdated } from "@vue/composition-api";
export default {
  name: "ChangeInVehicleIDV",
  props: ["changeInVehicleIDVData","idvUpperPermissibleRange","idvLowerPermissibleRange"],
  components: {
    FloatLabel,
  },
  setup(props, context) {
    let state = reactive({
      validateIdvRange: false,
    });
    function valiadteVehicleidv(){
      if(props.changeInVehicleIDVData.vehicleIDV.value && props.changeInVehicleIDVData.vehicleIDV.errorText == '') {
        state.validateIdvRange = false;
        context.parent.enableCalculatePremiumBtn('changeInVehicleIdv');
      }
    }
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;
    const onlyNumber =  functions.onlyNumber;
     onUpdated(()=>{
       context.parent.calculateSteps();
      // let progressStep = 0;
      // Object.values(props.changeInVehicleIDVData).forEach(obj => {
      //   if(obj.stepsMandatory){
      //     if(obj.value && !obj.errorText){
      //       progressStep++;
      //     }
      //   }
      // })
      // context.parent.updateSteps(progressStep);
    })
    return {
      state,
      isFloat,
      checkError,
      isInputError,
      onlyNumber,
      valiadteVehicleidv,
    };
  },
   directives: {
    evolvews: functions.evolvews
  }
};
</script>
<style scoped>
 .idv-range-error {
      border: 1px solid #b91c1c;
    }
</style>